import React, { useCallback, useEffect, useState } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { salesAPI } from '../services/api';

export default function SalesPersonSelect({
  value,
  onChange,
  label = 'Sales Person',
  helperText = 'Optional — leave unassigned if not applicable',
  size = 'small',
  fullWidth = true,
  disabled = false,
}) {
  const [salesUsers, setSalesUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadSales = useCallback(async () => {
    setLoading(true);
    try {
      const res = await salesAPI.getAll({ page: 1, limit: 500 });
      const allSales = res.data?.data || res.data || [];
      setSalesUsers(allSales);
    } catch (err) {
      console.error('Failed to load sales users:', err);
      setSalesUsers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSales();
  }, [loadSales]);

  const selectValue = value ? String(value) : '';

  return (
    <FormControl fullWidth={fullWidth} size={size} disabled={disabled || loading}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectValue}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
        label={label}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {salesUsers.map((sales) => {
          const salesId = String(sales.user_id || sales.id);
          return (
            <MenuItem key={salesId} value={salesId}>
              {sales.first_name} {sales.last_name} ({sales.email})
            </MenuItem>
          );
        })}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
